/* istanbul ignore file */
import SimpleList, { SimpleListProps } from './SimpleList';
import { LIST_PAGE_SIZE } from './List';

const RelatedList = ({ children, pageSize = LIST_PAGE_SIZE, ...props }: SimpleListProps) => {
  return (
    <SimpleList {...props} pageSize={pageSize}>
      {children}
    </SimpleList>
  );
};

export default RelatedList;
